import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Parser } from '@json2csv/plainjs';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile, NzUploadModule, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { delay, of, take } from 'rxjs';
import { UserClerkService } from '../../../core/user/user-clerk.service';
import { FileService } from './../../../core/file/file.service';
import { LambdaService } from './../../../shared/core/lambda.service';
import { bqList } from './bq';
import { codingList } from './coding';

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonModule, NzIconModule, NzUploadModule],
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss',
})
export class TestComponent {
  constructor(
    private fileService: FileService,
    private msg: NzMessageService,
    private userClerkService: UserClerkService,
    private lambdaService: LambdaService
  ) {}

  private _url: string | undefined;

  onChangeCreditsClick() {
    // return this.lambdaService
    //   .run$(ResourceName.userClerk, UserClerkGate.actions.changeCredits)
    //   .pipe(take(1))
    //   .subscribe();
  }

  onConvertToCsvClick() {
    const parser = new Parser();

    const newNormalObjectList = bqList
      .map((item: any) => {
        return this.toCsvObject(item, 'Normal Questions');
      })
      .filter((c: any) => !!c);

    const newCodingObjectList = codingList
      .map((item: any) => {
        return this.toCsvObject(item, 'Coding Questions');
      })
      .filter((c: any) => !!c);

    console.log('----newNormalObjectList:', newNormalObjectList);
    console.log('----newCodingObjectList:', newCodingObjectList);

    let csvNormal = parser.parse(newNormalObjectList);
    let csvCoding = parser.parse(newCodingObjectList);

    this.downloadCsv(csvNormal, 'normal.csv');
    this.downloadCsv(csvCoding, 'coding.csv');
  }

  private downloadCsv(csv: string, filename: string): void {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    a.click();
  }

  private toCsvObject(youtubeItem: any, category: 'Normal Questions' | 'Coding Questions') {
    console.log('---youtubeItem.snippet.thumbnails:', youtubeItem.snippet.title);
    console.log('---youtubeItem.snippet.thumbnails:', youtubeItem.snippet.thumbnails);

    if (youtubeItem?.snippet?.thumbnails?.maxres?.url) {
      return {
        blog: youtubeItem.snippet.title,
        Slug: this.convertToSlug(youtubeItem.snippet.title),
        'Thumbnail image': youtubeItem.snippet.thumbnails.maxres.url,
        'Main Image': youtubeItem.snippet.thumbnails.maxres.url,
        'Post Body': this.getYoutubeDescription(
          youtubeItem.snippet.resourceId.videoId,
          youtubeItem.snippet.title,
          youtubeItem.snippet.description
        ),
        'Post Summary': youtubeItem.snippet.description,
        Categories: category,
      };
    }

    return undefined;
  }

  private getYoutubeDescription(youtubeId: string, title: string, descripiton: string) {
    const youtubeDescription = `
<figure
  id=""
  class="w-richtext-figure-type-video w-richtext-align-center"
  style="padding-bottom: 45%"
  data-rt-type="video"
  data-rt-align="center"
  data-rt-max-width=""
  data-rt-max-height="45%"
  data-rt-dimensions="480:853"
  data-page-url="https://www.youtube.com/watch?v=${youtubeId}"
>
  <div id="">
    <iframe
      allowfullscreen="true"
      frameborder="0"
      scrolling="no"
      src="https://www.youtube.com/embed/${youtubeId}"
      title="${title}"
    ></iframe>
  </div>
</figure>
<p>
  ${descripiton}
</p>
`;
    return youtubeDescription;
  }

  convertToCsv() {
    const parser = new Parser();
    // let csv = parser.parse();
  }

  private convertToSlug(text: string): string {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '') // Remove non-alphanumeric characters except spaces
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .trim();
  }

  async uploadFileToS3(signedUrl: string) {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;

    console.log('-----fileInput:', fileInput.files);

    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      console.log('-----file.type:', file.type);
      try {
        const response = await fetch(signedUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type, // Ensure the content type matches the file's MIME type
          },
        });

        if (response.ok) {
          console.log('File uploaded successfully');
        } else {
          console.error('Failed to upload file', response.statusText);
        }
      } catch (error) {
        console.error('Error uploading file', error);
      }
    } else {
      console.error('No file selected');
    }
  }

  // Add an event listener to the file input element to trigger the upload
  onChange() {
    this.uploadFileToS3(this._url!);
  }

  onS3SignedUrlClick() {
    this.fileService
      .getPresignedUrlToUpload$('upload_test.png')
      .pipe(take(1))
      .subscribe((data) => {
        this._url = data?.url;
      });
  }

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;

    console.log('-----handleChange:', status);
    if (status !== 'uploading') {
      // console.log(file, fileList);
    }
    if (status === 'done') {
      this.msg.success(`${file.name} file uploaded successfully.`);

      console.log('----- fileList:', fileList);

      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = (file.originFileObj as any)?.url ?? '';
        }
        return file;
      });
    } else if (status === 'error') {
      this.msg.error(`${file.name} file upload failed.`);
    }
  }

  uploadFileHandler = (item: NzUploadXHRArgs) => {
    console.log('-----item:', item);
    return of(true)
      .pipe(delay(1000), take(1))
      .subscribe(() => {
        if (item.onSuccess) {
          console.log('-----file:', item.file);
          console.log('-----file:', item.postFile);

          item.file.url = 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png';

          item.onSuccess!(
            'Success',
            item.file as NzUploadFile,
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
          );
        }
      });
  };
}
